var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    "view-box": "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.333 10.833h10.142l-4.658 4.659L10 16.667 16.667 10 10 3.333 8.825 4.508l4.65 4.659H3.333v1.666z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowButtonIcon);
export default __webpack_public_path__ + "static/media/ArrowButtonIcon.c9dc9c75.svg";
export { ForwardRef as ReactComponent };